import axios from 'axios'
import {config} from '../Config/config'

const customer_relationService = {
    getAll : () => {
        const result = axios.get(config.apiUrl + '/customer_relation')
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    getById : (id) => {
        const result = axios.get(config.apiUrl + '/customer_relationById/' + id)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result[0]
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    
}


export default customer_relationService